import { render, staticRenderFns } from "./NewUserAlerts.vue?vue&type=template&id=d7af8a62&scoped=true&"
import script from "./NewUserAlerts.vue?vue&type=script&lang=js&"
export * from "./NewUserAlerts.vue?vue&type=script&lang=js&"
import style0 from "./NewUserAlerts.vue?vue&type=style&index=0&id=d7af8a62&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7af8a62",
  null
  
)

export default component.exports